import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router'
import {Observable} from 'rxjs'
import {filter, map, switchMap, take} from 'rxjs/operators'
import {UserSessionService} from '../../../services/user-session.service'
import {RedirectUrlService} from '../../../services/redirect-url.service'

@Injectable({
  providedIn: 'root'
})
export class IsLoggedInGuard  {
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.userSessionService.loggedIn$.pipe(
      filter(l => typeof l === 'boolean'),
      take(1),
      switchMap(() => this.userSessionService.user$),
      take(1),
      map(user => {
        if (user != null) {
          return true
        }
        this.redirectUrlService.setRedirectUrl(state.url)
        return this.router.createUrlTree(['/login'])
      })
    );
  }

  public constructor(
    private readonly userSessionService: UserSessionService,
    private readonly router: Router,
    private readonly redirectUrlService: RedirectUrlService,
  ) {
  }
}
